import { useState } from "react";
// material-ui
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Alert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";

//project imports
import { useGetNotificationByCodeQuery } from "shared/services/notification";

const NotificationAlert = styled(Alert)(({ theme }) => ({
  position: "fixed",
  zIndex: 1500,
  padding: theme.spacing(2),
  width: "100%",
  top: 0,
  borderRadius: 0,
  "& .MuiAlert-icon": {
    alignSelf: { xs: "flex-start", md: "center" },
  },
  "& .MuiAlert-message": {
    flex: 1,
  },
}));

const SystemNotificationAlert = ({ code }: { code: string }) => {
  const notificationOpen = JSON.parse(
    sessionStorage.getItem("notification-open") || "true",
  );
  const [open, setOpen] = useState(notificationOpen);
  const { data: notification } = useGetNotificationByCodeQuery({
    code,
  });

  const handleClose = () => {
    setOpen(false);
    sessionStorage.setItem("notification-open", "false");
  };
  if (!notification || !open) return null;
  return (
    <NotificationAlert
      variant='filled'
      color='warning'
      severity='warning'
      action={
        <IconButton
          aria-label='close'
          color='inherit'
          size='small'
          onClick={handleClose}
        >
          <CloseIcon fontSize='inherit' />
        </IconButton>
      }
    >
      <Typography>{notification?.text}</Typography>
    </NotificationAlert>
  );
};

export default SystemNotificationAlert;
